import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ReCaptchaV3Service } from 'ngx-captcha';
import { CommonsService } from 'src/app/services/commons.service';
import { SigninService } from 'src/app/services/signin.service';
import { CONSTANTS } from 'src/app/shared/constants';

@Component({
  standalone: false,
  selector: 'app-forget-pass',
  templateUrl: './forget-pass.component.html',
  styleUrls: ['./forget-pass.component.scss']
})
export class ForgetPassComponent implements OnInit {

  showProgress = false;
  recoverForm: UntypedFormGroup;
  key: string;
  receptionMessage: string;
  showFeedBack = false;

  constructor(private f: UntypedFormBuilder, private r: Router, private rc: ReCaptchaV3Service, private sign: SigninService, private cs: CommonsService) { }

  ngOnInit() {
    this.generateForm();
    this.getKey();
  }

  goToUrl = (url) => {
    this.r.navigateByUrl(url);
  }

  sendMail = () => {
    if (this.recoverForm.invalid) {
      return;
    }
    this.showProgress = true;
    this.recaptchaCheck(this.recoverForm.get('email').value)
  }

  /**
   * recupera una clave que se usa para el google captcha
   */
  private getKey = () => {
    if (!sessionStorage.getItem('k_ca')) {
      this.sign.getCaptchaKey().subscribe((key: any) => {
        sessionStorage.setItem('k_ca', key.gsv || key);
        sessionStorage.setItem('country', key.Country);
        if (key.Language) {
          sessionStorage.setItem('language', key.Language);
        }
        this.key =  key.gsv || key;
      });
    } else {
      this.key = sessionStorage.getItem('k_ca');
    }
  }
  /**
   * comprueba que es correcto el filtro propuesto del captcha
   * @param data: any
   */
  recaptchaCheck = (data) => {
    this.rc.execute(this.key, 'login', (token) => {
      this.sign.sendMail(data, token).subscribe((d: any) => {
        this.showProgress = false;
        if (d && d.Code !== 200) {
          this.showFeedBack = true;
          return;
        }
        this.receptionMessage = d.Message;
        this.cs.eventsAnalitics('conversion', 'Recuperacion de contraseña', 'OK');
      }, err => {
        console.error(err);
        this.showProgress = false;
      });
    }, { useGlobalDomain: true });
  }

  private generateForm = () => {
    this.recoverForm = this.f.group({
      email: new UntypedFormControl({ value: '', disabled: false }, [Validators.pattern(CONSTANTS.REG_EXP_MAIL), Validators.required])
    }, {});
  }
}
